<template>
  <div class="main-content-container container-fluid px-4">
    <page-header title="Edit" :subtitle="!!member ? `${member.first_name} ${member.last_name}`  : ``"/>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card elevation-z3">
          <!-- Form Example -->
          <!-- <d-card-header class="border-bottom">
            <h6 class="m-0">New Product </h6>
          </d-card-header> -->
          <d-card-body >
            <form v-if="!!member" id="add-team-member-form" @submit.prevent="updateMember">
              <vue-form-generator  :schema="schema" :model="member" :options="formOptions" />
              <input type="submit" form="add-team-member-form" value="save" class="btn btn-primary">
            </form>
             <loading v-else/>
          </d-card-body>

          <!-- <d-list-group flush>
            <d-list-group-item class="p-3">
              <d-row>
                <d-col>
                  <d-form @submit.prevent="addProduct">
                    <div class="form-group">
                      <label for="feInputAddress">Name</label>
                      <d-input id="feInputAddress" v-model="name" required/>
                    </div>

                    <div class="form-group">
                      <label for="feInputAddress2">Description</label>
                      <d-input id="feInputAddress2" placeholder="Apartment, Studio, or Floor" v-model="description" />
                    </div>

                    <d-form-row>
                      <d-col md="4" class="form-group">
                        <label for="feInputCity">SKU</label>
                        <d-input id="feInputCity" v-model="sku"/>
                      </d-col>

                      <d-col md="4" class="form-group">
                        <label for="feInputState">Price</label>
                        <d-input id="feInputCity" v-model="price" required/>
                      </d-col>

                      <d-col md="4" class="form-group">
                        <label for="feInputZip">Tax Rate</label>
                        <d-input id="feInputZip" v-model="tax" required/>
                      </d-col>
                    </d-form-row>
                    <d-button type="submit" class="float-right">Save New Product</d-button>
                  </d-form>
                </d-col>
              </d-row>
            </d-list-group-item>
          </d-list-group> -->
        </d-card>
      </d-col>
    </d-row>
  </div>
</template>


<script>
import {EDIT_MEMBER_SCHEMA, MEMBER_OPTIONS} from './schema'
import { removeEmptyProperties } from '@/helpers'

export default {
  data() {
    return {
      name: '',
      description: '',
      sku: '',
      tax: '',
      price: '',
      member: null,
      schema: EDIT_MEMBER_SCHEMA,
      formOptions: MEMBER_OPTIONS
    }
  },
  created() {
    this.member = this.$store.state.team.members.find(member => member.key === this.$route.params.key)
  },
  methods: {
    updateMember() {
      const updateMember = removeEmptyProperties(this.member)
      this.$store.dispatch("team/updateMember", updateMember)
      .then(response => {
        this.$router.push({ name: 'team' })
      })
    }
  },
};
</script>


<style scoped>
.action-btn {
  font-size: 1rem;
}
</style>